<template>
  <default-layout>
    <v-container>
      <v-row>
        <v-col md="12" class="text-center">
          <h1>Welcome to snapshot</h1>
          <h3>Please login to facebook</h3>
        </v-col>
      </v-row>
    </v-container>
  </default-layout>
</template>

<script>
import DefaultLayout from "@/layouts/Default";
export default {
  name: "Home",
  components: {
    DefaultLayout
  }
};
</script>
